import React from "react";
import "./Btn.css";


const CustomBtnLogo = ({
  label,
  onClick,
  type = "button",
  className,
  disabled = false,
  style,
  image,
}) => {

  return (
    <button
      type={type}
      onClick={onClick}
      className={`custom-btn-2 ${className}`}
      disabled={disabled}
      style={style}
    >
      <img src={image} alt="" srcset="" />
      {label}
    </button>
  );
};



export default CustomBtnLogo;